import React from "react";
import "./ContentPresets.css";

// Stock contents for tasks/interactions, offered as buttons next to the content
// field.
export const CONTENT_PRESETS = [
  "Follow-up on sent BF",
  "Follow-up on sent Proposal",
  "Follow-up on reply to sales enquiry",
  "Check-in after job completion",
  "Call pre-Results",
];

// Props:
//   onSelect – (content) => void, called with the clicked preset's text
const ContentPresets = ({ onSelect }) => (
  <div className="content-presets">
    {CONTENT_PRESETS.map((preset) => (
      <button key={preset} type="button" onClick={() => onSelect(preset)}>
        {preset}
      </button>
    ))}
  </div>
);

export default ContentPresets;
